import React from 'react';
import { Link, Route } from 'react-router-dom';
import styled from 'styled-components';

const StyledFooter = styled.div`
  margin-top: 10px;
  width: 100%;

  & > * {
    margin-bottom: 10px;
  }
`;

let loginComponents = [];
loginComponents.push(
  <>
    Passwort <Link to='/authentication/initiate-password-reset'>vergessen</Link>
    ?{' '}
  </>
);
loginComponents.push(
  <>
    Du möchtest Kursifant testen und Dich mit Deiner Organisation{' '}
    <Link to={'/register/new'}>registrieren</Link>?
  </>
);

let resetPasswordComponents = [];
resetPasswordComponents.push(
  <>
    Zurück zum <Link to={'/login'}>Login</Link>
  </>
);

const Footer = () => {
  return (
    <StyledFooter>
      <Route
        path={`/login`}
        render={() =>
          loginComponents.map((loginComponent, i) => (
            <div key={i}>{loginComponent}</div>
          ))
        }
      />

      <Route
        path='/register/new'
        render={props => {
          return (
            <>
              Du hast bereits einen Account?{' '}
              <Link to={'/login'}>Jetzt einloggen!</Link>
            </>
          );
        }}
      />

      <Route
        path='/register/at/:mandantRegisterId'
        render={({ match }) => {
          const { mandantRegisterId } = match.params;

          return (
            <>
              Du hast bereits einen Account?{' '}
              <Link to={`/login?registerId=${mandantRegisterId}`}>
                Jetzt einloggen!
              </Link>
            </>
          );
        }}
      />

      <Route
        path={`/authentication/initiate-password-reset`}
        render={() =>
          resetPasswordComponents.map((c, i) => <div key={i}>{c}</div>)
        }
      />
    </StyledFooter>
  );
};

export default Footer;
